import loadable from '@loadable/component';

export const CoachmagSiteWrapper = loadable(
  () => import(/* webpackChunkName: "coachmag-site" */ './CoachmagSiteWrapper'),
);
